import { Injectable } from '@angular/core';
import { facetAdaptor, resourceAdaptor } from 'qp-adaptor';
import { SearchService as LibrarySearchService, createSearchService } from 'qp-storefront';
import { AspectRatio, FacetVm, Resource, ResourceVm } from 'qp-ui-interface';
import { getAppVersion, getDeviceType } from 'qp-utility';
import { LocalStorageKeys } from '../shared/LocalStorageKeys';
import { ErrorEvents } from '../shared/models/ErrorEvents';
import { ErrorFactory } from '../shared/modules/errors/handler/ErrorFactory';
import { ConfigService } from '../shared/services/config/config.service';
import { StorefrontPolicyService } from '../shared/services/firstlight/storefront-policy/storefront-policy.service';
import { LocalStorageService } from '../shared/services/local-storage/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  private searchService: LibrarySearchService;
  constructor(private readonly configService: ConfigService, private readonly policyService: StorefrontPolicyService, private readonly localStorage: LocalStorageService) {
    this.initService();
  }

  initService() {
    this.searchService = createSearchService(
      this.configService.applicationConfig.searchHistoryURL,
      this.configService.applicationConfig.noSearchResultsURL,
      this.configService.applicationConfig.vodMetaDataURL,
      this.policyService.getPolicy(),
      true
    );
  }

  public async fetchSearchResults(
    searchTerm: string,
    aspectRatio: AspectRatio,
    contentType?: string,
    pageNumber: string = '1',
    pageSize: string = '50'
  ): Promise<{ resources: ResourceVm[]; facets: FacetVm[] }> {
    try {
      const response = await this.searchService.getSearchResults(searchTerm, pageNumber.toString(), pageSize.toString(), contentType);
      const resources = response.resources
        ? response.resources.map((res: Resource) =>
            resourceAdaptor(
              res,
              this.configService.applicationConfig.imageResizeURL,
              getDeviceType(),
              this.localStorage.getItem(LocalStorageKeys.LANG),
              '0-' + aspectRatio,
              null,
              null,
              null,
              getAppVersion()
            )
          )
        : [];
      const facets = response.facet ? facetAdaptor(response.facet, true) : [];
      return { resources, facets };
    } catch (error) {
      return Promise.reject(ErrorFactory.get(error, ErrorEvents.SEARCH_FETCH_ERROR));
    }
  }

  /**
   * Get default/popular searches
   *
   * @param pageNumber
   * @param pageSize
   */
  async getPopularSearches(aspectRatio: AspectRatio, pageNumber: number = 1, pageSize: number = 20): Promise<ResourceVm[]> {
    try {
      const response = await this.searchService.getNoSearchResults(`${pageNumber}`, `${pageSize}`);
      return response.resources
        ? response.resources.map((res: Resource) =>
            resourceAdaptor(
              res,
              this.configService.applicationConfig.imageResizeURL,
              getDeviceType(),
              this.localStorage.getItem(LocalStorageKeys.LANG),
              '0-' + aspectRatio,
              null,
              null,
              null,
              getAppVersion()
            )
          )
        : [];
    } catch (error) {
      return Promise.reject(ErrorFactory.get(error, ErrorEvents.SEARCH_FETCH_ERROR));
    }
  }
}
